export default __webpack_public_path__ + "static/media/02.72e19384.jpg";